

import { BLOG_DETAIL, PRODUCTS_RECOMMEND, BLOGS_RANDOM } from '../../store/store.const'
import SimpleProductElement from '../../components/blog/simple_product'
import SimpleSearchBlogElement from '../../components/blog/single'
import AppendixBlog from '@/components/blog/appendix_blog.vue'
import ExpandContact from '@/components/contact/ExpandContact.vue'
import { removeVietnameseTones, textToSlug } from '@/utils/utils'

export default {
  name: 'ConsultingBlog',
  components: { SimpleProductElement, SimpleSearchBlogElement, AppendixBlog, ExpandContact },
  layout: 'default-details',
  async asyncData({ store, route, redirect }) {
    let res = {}
    try {
      res = await store.dispatch(BLOG_DETAIL, { slug: route.params.slug }) // fetchDataBlog
    } catch (e) {
      console.error(e)
      redirect(301, '/')
    }
    if (res.data) {
      const dataBlog = res.data
      return {
        dataBlog
      }
    }
    redirect(301, '/')
  },
  data() {
    const dataId = this.$route.params.slug
    return {
      slug: dataId,
      id: '',
      recommendProducts: [],
      blogsRandom: [],
      listTagH2: [],
      dataBlogContentConvert: ''
    }
  },
  head() {
    return this.metaPixelScripts
  },
  computed: {
    metaPixelScripts() {
      const scripts = {}
      const defaultTitle = this.dataBlog.title + ' - ' + this.$t('home.title')
      scripts.title = this.dataBlog?.meta_title ?? defaultTitle
      scripts.meta = [
        { hid: 'title', name: 'title', content: this.dataBlog?.meta_title ?? defaultTitle },
        { hid: 'description', name: 'description', content: this.dataBlog.meta_description ?? '' },
        { hid: 'url', name: 'url', content: this.dataBlog.meta_url ?? '' },
        { hid: 'identifier-URL', name: 'identifier-URL', content: this.dataBlog.meta_url ?? '' },
        { hid: 'twitter:card', name: 'twitter:card', content: 'website' },
        { hid: 'twitter:title', name: 'twitter:title', content: this.dataBlog?.meta_title ?? defaultTitle },
        { hid: 'twitter:description', name: 'twitter:description', content: this.dataBlog.meta_description ?? '' },
        { hid: 'twitter:image', name: 'twitter:image', content: this.dataBlog.meta_image ?? '' },
        { hid: 'twitter:keywords', name: 'twitter:keywords', content: this.dataBlog.meta_keywords ?? '' },
        { hid: 'og:type', property: 'og:type', content: 'website' },
        { hid: 'og:title', property: 'og:title', content: this.dataBlog?.meta_title ?? defaultTitle },
        { hid: 'og:description', property: 'og:description', content: this.dataBlog.meta_description ?? '' },
        { hid: 'og:image', property: 'og:image', content: this.dataBlog.meta_image ?? '' },
        { hid: 'og:keywords', property: 'og:keywords', content: this.dataBlog.meta_keywords?.join(',') ?? '' },
        { hid: 'robots', name: 'robots', content: this.dataBlog.meta_robots?.join(',') ?? '' }
      ]
      if (this.dataBlog.canonical !== null) {
        scripts.link = [
          { hid: 'canonical', rel: 'canonical', href: this.dataBlog.canonical }
        ]
      }
      return scripts
    }
  },
  created() {
    this.id = this.dataBlog.id
    this.productRecommend()
    this.blogRelated()
    this.convertTagH2(this.dataBlog.content)
  },
  mounted() {
    const indexML = this.$route.hash.slice(1, this.$route.hash.indexOf('_'))
    if (indexML) {
      this.emitIndex(indexML)
    }
    this.updateSlug()
  },
  methods: {
    async productRecommend() {
      const res = await this.$store.dispatch(PRODUCTS_RECOMMEND, { id: this.id })
      if (res.data?.length) {
        this.recommendProducts = res.data
      }
    },
    async blogRelated() {
      const search = {
        blog_id: this.id
      }
      const res = await this.$store.dispatch(BLOGS_RANDOM, { filters: search })
      if (res.data?.length) {
        this.blogsRandom = res.data
      }
    },
    showSold(val) {
      let sold = Number(val)
      if (sold > 1000) {
        sold = (sold / 1000).toFixed(1) + 'k'
        sold = sold.replace('.0', '')
        sold = sold.replace('.', ',')
      }
      return sold
    },
    redirectedSearchTag(value) {
      this.$router.push({ path: '/blogs/search', query: { search: value }})
    },
    updateSlug() {
      if (this.$router.currentRoute.fullPath === '/blogs/nhung-mau-ke-tivi-go-huong-hien-dai-pho-bien-hien-nay') {
        this.$router.push({ path: '/blogs/mau-ke-tivi-go-huong' })
      }
    },
    convertTagH2(innerHtml) {
      if (innerHtml) {
        const check = innerHtml.replaceAll('</h2>', 'tagH2').replaceAll('<h2>', 'tagH2')
        const searchStr = 'tagH2'
        let startIndex = 0
        const positions = []
        while ((startIndex = check.indexOf(searchStr, startIndex)) > -1) {
          positions.push(startIndex)
          startIndex += searchStr.length
        }
        const res = []
        for (let index = 0; index < positions.length; index = index + 2) {
          if (check.slice(positions[index], positions[index + 1]).split(' ')[0].length <= 8) {
            res.push(check.slice(positions[index], positions[index + 1]).replaceAll('tagH2', ''))
          }
        }

        for (let index = 1; index <= res.length; index++) {
          innerHtml = innerHtml.replaceAll(`<h2>${index}. `, `<h2 id="index_${index}">${index}. `)
        }
        this.dataBlogContentConvert = innerHtml
        this.listTagH2 = res
      }
    },
    emitIndex(index) {
      const el = document.getElementById(`index_${index}`)
      let headerOffset = 150
      if (this.$device.isDesktop) {
        headerOffset = 150
      } else if (this.$device.isTablet) {
        headerOffset = 200
      } else {
        headerOffset = 0
      }
      const elPos = el.getBoundingClientRect().top
      const offsetPos = elPos + window.pageYOffset - headerOffset

      setTimeout(() => {
        window.scrollTo({
          top: offsetPos,
          behavior: 'smooth',
          block: 'start'
        })
      }, 200)
    },
    slugData(name) {
      return textToSlug(removeVietnameseTones(name))
    }
  }
}
